import { render, staticRenderFns } from "./LandingCreditScorePage.vue?vue&type=template&id=61974ed7&scoped=true"
import script from "./LandingCreditScorePage.vue?vue&type=script&lang=ts"
export * from "./LandingCreditScorePage.vue?vue&type=script&lang=ts"
import style0 from "./LandingCreditScorePage.vue?vue&type=style&index=0&id=61974ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61974ed7",
  null
  
)

export default component.exports